import { render, staticRenderFns } from "./editRecipientInformation.vue?vue&type=template&id=6f6a6029&scoped=true"
import script from "./editRecipientInformation.vue?vue&type=script&lang=js"
export * from "./editRecipientInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6a6029",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6a6029')) {
      api.createRecord('6f6a6029', component.options)
    } else {
      api.reload('6f6a6029', component.options)
    }
    module.hot.accept("./editRecipientInformation.vue?vue&type=template&id=6f6a6029&scoped=true", function () {
      api.rerender('6f6a6029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/editRecipientInformation.vue"
export default component.exports